export const FCA_PAYER = "FCA" as const;
export const CUSTOMER_PAYER = "CUSTOMER" as const;

export type PayerUserType = typeof FCA_PAYER | typeof CUSTOMER_PAYER;
